import styled from 'styled-components';

export const Container = styled.div`
	grid-area: main;
	background-color: transparent;
`;
